import { colors } from '@ardoq/design-tokens';
import { Breadcrumbs2, ComponentRepresentation } from '@ardoq/basic-components';
import { IconName, IconSize, WorkspaceIcon } from '@ardoq/icons';
import { InlineText } from '@ardoq/typography';
import { FlexBox } from '@ardoq/layout';
import { ComponentWithContextOption } from './types';
import { OptionContainer } from './atoms';

export const ComponentWithContext = ({
  name,
  path,
  rootWorkspaceName,
  representationData: { icon, isImage, contrastColor, value },
  isNewComponent,
  folderPath,
  labels,
}: ComponentWithContextOption) => {
  const newComponentLabel = labels?.newComponent ?? 'New component';
  const noWorkspaceSelectedLabel =
    labels?.noWorkspaceSelected ?? 'No workspace selected';
  return (
    <OptionContainer>
      {isNewComponent && (
        <InlineText variant="caption" color="textSubtle">
          {newComponentLabel}
        </InlineText>
      )}
      {folderPath && folderPath.length > 0 && (
        <InlineText variant="caption" color="textSubtle">
          <Breadcrumbs2 breadcrumbs={folderPath} />
        </InlineText>
      )}
      <FlexBox align="center" gap="xsmall">
        {rootWorkspaceName && (
          <WorkspaceIcon iconSize={IconSize.SMALL} color={colors.grey500} />
        )}
        <InlineText variant="caption" color="textSubtle">
          {rootWorkspaceName ? rootWorkspaceName : noWorkspaceSelectedLabel}
        </InlineText>
      </FlexBox>
      {path && (
        <InlineText variant="caption" color="textSubtle">
          <Breadcrumbs2
            breadcrumbs={path}
            leadingIcon={{
              name: IconName.NONE,
              size: IconSize.SMALL,
              rightMargin: 'xsmall',
            }}
          />
        </InlineText>
      )}
      <FlexBox align="center" gap="small">
        <ComponentRepresentation
          isImage={isImage ?? false}
          value={value ?? null}
          icon={icon}
          iconSize={IconSize.MEDIUM}
          style={{
            fontSize: IconSize.MEDIUM,
            color: contrastColor,
          }}
        />
        <InlineText variant="text1">{name}</InlineText>
      </FlexBox>
    </OptionContainer>
  );
};
